import axiosInstance from "./AxiosInstance";
import Api from "../constants/Api";

export const listBots = () => axiosInstance.get(Api.whatsapp.bot);

export const listConversations = (filters = []) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/findByFilters`, { filters });

export const listMessageLogs = (filters = []) =>
    axiosInstance.post(`${Api.whatsapp.message_log}/findByFilters`, { filters });

export const downloadMessageMedia = (messageLogId) =>
    axiosInstance.get(`${Api.whatsapp.message_log}/${messageLogId}/media`, { responseType: "blob" });

export const closeConversation = (conversationId) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/${conversationId}/close`);

export const reopenConversation = (conversationId) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/${conversationId}/reopen`);

export const takeOverConversation = (conversationId) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/${conversationId}/take-over`);

export const returnToBotConversation = (conversationId) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/${conversationId}/return-to-bot`);

export const sendConversationMessage = (conversationId, message) =>
    axiosInstance.post(`${Api.whatsapp.conversation}/send-message`, { conversationId, message });

export const getWhatsappMetrics = () =>
    axiosInstance.get(Api.whatsapp.conversation_metrics);

export const getWhatsappAttendanceMetrics = () =>
    axiosInstance.get(Api.whatsapp.attendance_metrics);

export const getWhatsappDropOffMetrics = () =>
    axiosInstance.get(Api.whatsapp.drop_off_metrics);
